import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Utility functions for Amplitude Analytics
 */
import { CheggEnv, getCheggEnv } from '@chegg/utils';

// =============================================================================
// CONSTANTS
// =============================================================================

export var APP_VERSION = '1.0.0';

// =============================================================================
// COOKIE UTILITIES
// =============================================================================

/**
 * Get cookie value by name
 */
export function getCookie(name) {
  var cookieString = document.cookie;
  var cookies = cookieString.split('; ');
  var _iterator = _createForOfIteratorHelper(cookies),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var cookie = _step.value;
      var _cookie$split = cookie.split('='),
        _cookie$split2 = _slicedToArray(_cookie$split, 2),
        cookieName = _cookie$split2[0],
        cookieValue = _cookie$split2[1];
      if (cookieName === name) {
        return cookieValue || null;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return null;
}

// =============================================================================
// AUTHENTICATION UTILITIES
// =============================================================================

/**
 * Check if user is hard logged in by looking for authentication indicators
 */
export function isHardLoggedIn() {
  return document.cookie.includes('id_token=') || document.cookie.includes('auth_token=') || localStorage.getItem('isAuthenticated') === 'true';
}

// =============================================================================
// CONFIGURATION UTILITIES
// =============================================================================

/**
 * Get the appropriate Amplitude API key based on the environment
 */
export function getAmplitudeApiKey() {
  return getCheggEnv() === CheggEnv.PROD ? 'b187e8b9918b00d161ce03017d355298' // production
  : '1932b4101d16be26ecd33bb9cf543b03'; // non-production
}